import { styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(1, 0),
  color: theme.palette.text.secondary,
}));

const Item = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

const Swatch = styled("span")(({ theme }) => ({
  width: 12,
  height: 12,
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
}));

const FacilitySwatch = styled(Swatch)(({ theme }) => ({
  background: theme.palette.background.paper,
}));

const OrganisationSwatch = styled(Swatch)(({ theme }) => ({
  background: theme.palette.grey[100],
}));

export const PriceListLegend: FC = () => (
  <Wrapper data-testid="priceList.legend">
    <Item>
      <FacilitySwatch />
      <Typography variant="caption">
        <FormattedMessage
          id="priceList.legend.facility"
          defaultMessage="Facility prices (editable)"
        />
      </Typography>
    </Item>
    <Item>
      <OrganisationSwatch />
      <Typography variant="caption">
        <FormattedMessage
          id="priceList.legend.organisation"
          defaultMessage="Organisation prices (read-only at this facility)"
        />
      </Typography>
    </Item>
  </Wrapper>
);

export default PriceListLegend;
